/**
 * KiekkoKingi section controller: expert-help
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (function () {
        const rootId = kkScript.dataset.rootId;
        var registry = window.__kiekkokingExpertControllers = window.__kiekkokingExpertControllers || { items: {}, bound: false };
  
        function destroy(id) {
          var controller = registry.items[id];
          if (!controller) return;
          if (controller.observer) controller.observer.disconnect();
          if (controller.toggle && controller.onToggle) controller.toggle.removeEventListener('click', controller.onToggle);
          if (controller.video) {
            controller.video.pause();
            if (controller.onVideoState) {
              controller.video.removeEventListener('play', controller.onVideoState);
              controller.video.removeEventListener('pause', controller.onVideoState);
              controller.video.removeEventListener('ended', controller.onVideoState);
            }
          }
          delete registry.items[id];
        }
  
        registry.init = function (root) {
          if (!root || !root.id) return;
          destroy(root.id);
  
          var video = root.querySelector('[data-kk-expert-video]');
          var toggle = root.querySelector('[data-kk-expert-video-toggle]');
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var motion = root.getAttribute('data-motion') || 'none';
          var shouldAutoplay = root.getAttribute('data-video-autoplay') === 'true';
          var allowMobileVideo = root.getAttribute('data-video-mobile') === 'true';
          var isMobile = window.matchMedia('(max-width: 719px)').matches;
          var controller = { root: root, video: video, toggle: toggle, observer: null, onToggle: null, onVideoState: null };
  
          registry.items[root.id] = controller;
  
          function updateVideoControl() {
            if (!video || !toggle) return;
            var playing = !video.paused && !video.ended;
            var playIcon = toggle.querySelector('[data-kk-icon-play]');
            var pauseIcon = toggle.querySelector('[data-kk-icon-pause]');
            toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
            toggle.setAttribute('aria-label', playing ? (root.dataset.videoPauseLabel || '') : (root.dataset.videoPlayLabel || ''));
            if (playIcon) playIcon.toggleAttribute('hidden', playing);
            if (pauseIcon) pauseIcon.toggleAttribute('hidden', !playing);
          }
  
          function playIfAllowed() {
            if (!video || !shouldAutoplay || reducedMotion || (isMobile && !allowMobileVideo)) {
              updateVideoControl();
              return;
            }
            video.muted = true;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.then(updateVideoControl).catch(updateVideoControl);
            } else {
              updateVideoControl();
            }
          }
  
          if (video) {
            controller.onVideoState = updateVideoControl;
            video.addEventListener('play', controller.onVideoState);
            video.addEventListener('pause', controller.onVideoState);
            video.addEventListener('ended', controller.onVideoState);
  
            if (reducedMotion || (isMobile && !allowMobileVideo)) video.pause();
  
            if (toggle) {
              controller.onToggle = function () {
                if (video.paused) {
                  video.muted = true;
                  var promise = video.play();
                  if (promise && typeof promise.catch === 'function') promise.catch(updateVideoControl);
                } else {
                  video.pause();
                }
                updateVideoControl();
              };
              toggle.addEventListener('click', controller.onToggle);
              updateVideoControl();
            }
          }
  
          if (motion !== 'none' && !reducedMotion) root.classList.add('is-motion-ready');
  
          function reveal() {
            root.classList.add('is-revealed');
            playIfAllowed();
          }
  
          if ('IntersectionObserver' in window) {
            controller.observer = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                reveal();
                controller.observer.disconnect();
              });
            }, { rootMargin: '120px 0px', threshold: 0.08 });
            controller.observer.observe(root);
          } else {
            reveal();
          }
  
          if (reducedMotion || motion === 'none') root.classList.add('is-revealed');
        };
  
        registry.init(document.getElementById(rootId));
  
        if (!registry.bound) {
          document.addEventListener('shopify:section:load', function (event) {
            var root = event.target.matches && event.target.matches('[data-kk-expert]')
              ? event.target
              : event.target.querySelector && event.target.querySelector('[data-kk-expert]');
            if (root) registry.init(root);
          });
  
          document.addEventListener('shopify:section:unload', function (event) {
            var root = event.target.matches && event.target.matches('[data-kk-expert]')
              ? event.target
              : event.target.querySelector && event.target.querySelector('[data-kk-expert]');
            if (root) destroy(root.id);
          });
  
          registry.bound = true;
        }
      })();
})();
